import { $api } from '#/api/client'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type -- Type-inference helper; return type is inferred from the concrete call to avoid complex generic notation on UseMutationMethod
const _inferUpdateProfileMutation = () => $api.useMutation('patch', '/companies/{companyId}/users/{userId}')
type TUpdateProfileMutation = ReturnType<typeof _inferUpdateProfileMutation>

export const useUpdateProfile = (): TUpdateProfileMutation => {
  return $api.useMutation('patch', '/companies/{companyId}/users/{userId}')
}
